import React from 'react';
import type { FollowUpItem } from '@/services/bff/types/follow-up';
import { MarkdownView } from './view';
export function LegacyFollowUpFiles({ record }: { record: FollowUpItem }) {
  const links = (value?: string) =>
    String(value || '')
      .split(',')
      .map((url) => url.trim())
      .filter(Boolean);
  const markdown = [
    ...links(record.picUrls).map((url, i) => `![图片 ${i + 1}](${url})`),
    ...links(record.fileUrls).map((url, i) => `[附件 ${i + 1}](${url})`),
  ].join('\n\n');
  return markdown ? (
    <MarkdownView content={markdown} contentFormat="markdown" />
  ) : null;
}
